<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="user.firstName + ' ' + user.lastName"/>
        <show-actions
          :editOnly=true
          @clickOnEditBtn="clickOnEditBtn"
        ></show-actions>
      </div>
      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="row">

          <div class="col-12 col-md-6 col-lg-4 mb-2">
            <div class="bold-text main-color">
              {{ $t('user.FirstName') }}
            </div>
            <div class="mt-2">
              {{ getValue("firstName") }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2">
            <div class="bold-text main-color">
              {{ $t('user.LastName') }}
            </div>
            <div class="mt-2">
              {{ getValue("lastName") }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2">
            <div class="bold-text main-color">
              {{ $t('user.Username') }}
            </div>
            <div class="mt-2">
              {{ getValue("username") }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2">
            <div class="bold-text main-color">
              {{ $t('user.Rpps') }}
            </div>
            <div class="mt-2">
              {{ getValue("rpps") }}
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2">
            <div class="bold-text main-color">
              {{ $t('user.NbQuestionnaireRestant') }}
            </div>
            <div class="mt-2">
              <div v-if="getValue('nbQuestionnaireRestant')===0" style="color:red">{{ getValue('nbQuestionnaireRestant') }}</div>
              <div v-else>{{ user.isUnlimited ? 'Illimité' : getValue("nbQuestionnaireRestant") }}</div>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2">
            <div class="bold-text main-color">
              {{ $t('user.NbQuestionnaireFait') }}
            </div>
            <div class="mt-2">
              <div>
                <a @click=goToQuestionnaire href="javascript:void(0)">{{ getValue("nbQuestionnaireFait") }}</a>
              </div>

            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-4 mb-2">
            <div class="bold-text main-color">
              {{ $t('user.PartnerCode') }}
            </div>
            <div class="mt-2">
              {{ getValue("partnerCode") }}
            </div>
          </div>

        </div>
      </b-card>
    </b-container>
<!--    <User-edit-modal :selectedUser="user" @didEditUser="didEditUser()"></User-edit-modal>-->
  </div>
</template>

<script>
import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import ShowActions from "../../components/b122/ShowActions";
// import UserEditModal from "./UserEditModal";
import {mapActions} from "vuex";

export default {

  name: 'UserShow',

  components: {
    BackArrow,
    ShowActions,
    // UserEditModal
  },

  data() {
    return {
      userId: this.$route.params.userId,
      user: {}
    }
  },

  computed: {
    getValue() {
      return property => (this.user[property] || this.user[property] == false) ? this.user[property] : "N/A"
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    ...mapActions(["setFilterTable"]),

    fetchData() {
      this.fetchUser()
    },

    fetchUser() {
      api
        .get(`/user/${this.userId}`)
        .then(response => {
          this.user = response.data
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: this.user.id
        }
      })
    },

    didEditUser() {
      this.fetchUser()
    },

    goToQuestionnaire() {

      let filter = [
          {
            position: 2,
            selectedValue: this.user.id
          }
        ],
        dataFilter = {tableName: "B122TableQuestionnaire", filters: filter}

      this.setFilterTable(dataFilter)

      // this.setPropertyTableState({
      //   identifier: "B122TableQuestionnaire",
      //   property: "search",
      //   value: this.user.firstName + " " + this.user.lastName
      // })

      this.$router.push({
        name: 'QuestionnaireIndex',
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserShow.vue